/*
 * @Auther: 罗耀祖
 * @Date: 2021-07-07 12:05:28
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2021-08-31 13:47:35
 * @name: 省市区
 * @Description: 省市区数据,用于省市区选择器
 * @FilePath: \preSaleNafterSaleBackstage\src\mixins\regionSelect.js
 * @Author: DESKTOP-1QU67QM
 */
import region from '@/libs/region.json';
export default {
    data() {
        return {
            region: region, //地址json数据
            provinceSelected: '', //选择的省
            citySelected: '', //选择的市
            distSelected: '', //选择的区
        }
    },
    computed: {
        // 省
        province() {
            return this.region?.map(x => x.name) ?? [];
        },
        // 市
        city() {
            return this.region?.find(x => x.name === this.provinceSelected)?.city?.map(x => x.name) ?? [];
        },
        // 区
        dist() {
            return this.region?.find(x => x.name === this.provinceSelected)?.city?.find(x => x.name === this.citySelected)?.area ?? [];
        }
    },
    watch: {
        // 省变化时,重置市、区
        provinceSelected: {
            handler(nv, ov) {
                this.citySelected = '';
                this.distSelected = '';
            },
            immediate: false,
            deep: true,
        },
        // 市变化时，重置区
        citySelected: {
            handler(nv, ov) {
                this.distSelected = '';
            },
            immediate: false,
            deep: true,
        },
    }
}